var render = function (_h,_vm) {var _c=_vm._c;return _c('img',_vm._g(_vm._b({class:[
    'jz-icon',
    {
      'jz-highlight': _vm.props.highlight
    },
    _vm.data.class,
    _vm.data.staticClass
  ],attrs:{"src":_vm.props.src}},'img',_vm.data.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }